import './DefaultCardHeader.css';

export default function DefaultCardHeader({
  children,
}) {
  return (
    <div className="default-card-header">{children}</div>
  );
}
